import { useRouter } from 'next/router';
import React, { useEffect, useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/WarningSharp';

import { AppContext } from './AppState';
import ConfirmModal from './ConfirmModal';


const useStyles = makeStyles((theme) => ({
  icon: {
    marginBottom: theme.spacing(-0.5),
  },
}));

export default function NavigateModal(props) {
  const { visible, setVisible } = props;

  const router = useRouter();
  const classes = useStyles();
  const { navWarning, setNavWarning, redirect, setRedirect } = useContext(AppContext);

  const [routerPushed, setRouterPushed] = useState(false);

  useEffect(() => {
    if (!router.isReady) return;
    if (!redirect) {
      setRouterPushed(false);
      return;
    }
    if (navWarning) {
      setVisible(true);
    } else {
      if (redirect.startsWith('http')) {
        window.location = redirect;
      } else if (!routerPushed) {
        setRouterPushed(true);
        router.push(redirect.slice());
      }
      setRedirect(null);
    }
  }, [redirect, navWarning, setVisible, routerPushed, setRedirect, router]);

  async function handleConfirmNavigate(confirm) {
    setVisible(false);
    if (confirm) {
      setNavWarning(false);
    } else {
      setRedirect(null);
    }
  }

  return (
    <ConfirmModal
      visible={visible}
      title={<><WarningIcon className={classes.icon}/> Confirm navigation</>}
      message={<>Are you sure you want to leave this page?  Changes in progress won&apos;t be saved.</>}
      onYes={() => handleConfirmNavigate(true)}
      onNo={() => handleConfirmNavigate(false)}
      confirmText='Leave page'
      cancelText='Stay on page'
    />
  );
}
